import React from 'react'
import './css/Footer.css'

function Footer() {
    return (
        <>
        <hr className="text-white"/>
        <div className="footer">
        © Copyright 2021 Web And App Development Classes - All Rights Reserved
      </div>
      </>
    )
}

export default Footer
